// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ClsP","selected":"styles_selected__QEULK"};